// removed by extract-text-webpack-plugin
module.exports = {"appFooter":"_2kCLkxr_wBozQCcwQ7Ct2m","footerContentRow":"_1vPft0k-axC41F9_ayQbJu","column":"dNzgBppqIu4zVDkD2-s41","socialRow":"_1T5uX5gbPN3UDckbVMxVM2","languageButtons":"-WmNdIiUBbhLJBU_V65wA","footerNavMenu":"_2w3yw42CeaRQRj9ghniamA","footerNavLink":"_3CX1k51y_COS65H6LDmLbt","footerLogo":"QH5uvRuSoR2kcpo24nj8h"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footerComponent.scss
// module id = 677
// module chunks = 22